import { AudioPlayerControls } from '@rhg/components/media/audio-player/types';
import { useMemo } from 'react';
import { QueueSource, QueueSourceKind } from '../../types';
import { useAudioControls } from '../use-audio-controls';

/**
 * Controls for the loaded queue. A program source classifies exactly as
 * `useAudioControls`. A multi-track playlist is always `Playlist`; a 1-track
 * playlist classifies its track as a single, whatever its program's size.
 */
export function useQueueSourceControls({
    queueSource,
    program,
    playingGuide,
}: {
    queueSource: QueueSource;
} & Parameters<typeof useAudioControls>[0]): AudioPlayerControls {
    const isPlaylist = queueSource.kind === QueueSourceKind.Playlist;
    const isMultiTrackPlaylist = isPlaylist && queueSource.guides.length > 1;
    // useAudioControls classifies by program.totalGuides.
    const singleTrackProgram = useMemo(
        () =>
            isPlaylist && program ? { ...program, totalGuides: 1 } : program,
        [isPlaylist, program]
    );
    const perTrack = useAudioControls({
        program: singleTrackProgram,
        playingGuide,
    });
    return isMultiTrackPlaylist ? AudioPlayerControls.Playlist : perTrack;
}
